export const enum ImageRatio {
  UltraWide21to9 = 2.33,
  Wide16to9 = 1.78,
  Default3to2 = 1.5,
  Square = 1,
}
